import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { updateTitlePageCurrent } from "store/topbarReducer/topbarSlice";
import { v4 } from "uuid";

const Breadcrumb = ({ breadCrumbs }) => {
	const namePage = breadCrumbs.at(-1).breadcrumb.props.children;
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(updateTitlePageCurrent(namePage));
	}, [dispatch, namePage]);
	return (
		<div className='global-breadcrumb'>
			<ol className='items-center flex text-sm'>
				{breadCrumbs.map(({ match, breadcrumb }) => (
					<li key={v4()}>
						<NavLink key={match.pathname} to={match.pathname}>
							{breadcrumb}
						</NavLink>
					</li>
				))}
			</ol>
		</div>
	);
};

export default Breadcrumb;
